common.View.create('crud::form.inputs.Tags', {

	/**
	 * Called when DOM is ready.
	 */
	onDOMLoad() {
		this.initTags();
	},

	initTags()
	{
		// Get the input that needs to be converted to the tags input
		let $input = this.element.find('input');

		// Get user given tag options
		let options = this.initOptions($input);

		// Configure dropdown if maxItems is specified
		if (options.maxitems) {
			options.dropdown = {
				enabled: true,
				maxItems: parseInt(options.maxitems) || 50, // Convert to number, default to 50
				...options.dropdown // Allow other dropdown options to be merged in
			};
		}

		// Run tagify
		let tagify = new Tagify($input.get(0), options);

        // Listen for the 'focus' event to show dropdown
        if( options.enforceWhitelist ) {
            tagify.on('focus', function() {
                tagify.dropdown.show.call(tagify, ''); // Passing an empty string to show all suggestions
            });
        }

        tagify.DOM.input.addEventListener('paste', e => {
            // Update tagify value with current value and pasted value on the user selection
            let value = tagify.DOM.input.textContent,
                pastedValue = e.clipboardData.getData('text');

            // Get parts that could be seen as tags by splitting. Start with @ and end with space or special character
            let parts = pastedValue.split(/@(\w+)(\s|\W)/);

            // Check if values exists within the whitelist, then add it as a tag, otherwise just add it as a text
            parts.forEach(part => {
                console.log( part );
                if (tagify.settings.whitelist.includes(part)) {
                    //tagify.addTags(part);
                } else {
                    tagify.addMixTags(part);
                }
            });

            // Prevent default paste event
            e.preventDefault();
        });
	},

    initOptions($input)
    {
        let options = [],
            whitelist = ['name', 'type', 'value', 'class'],
            attrs = $input.get(0).attributes;

        let attributeToPropertyMap = {
            'enforcewhitelist': 'enforceWhitelist',
            // Add other mappings as needed
        };

        // Loop attributes of input
        for (var i = attrs.length - 1; i >= 0; i--) {
            let name = attrs[i].name;

            // Attribute is not whitelisted?
            if( !whitelist.includes(name) ) {
                // Get attr name, value
                let attrName = attributeToPropertyMap[attrs[i].nodeName] || attrs[i].nodeName, 
                    attrValue = attrs[i].nodeValue;

                if (name === 'whitelist') {
                    attrValue = attrs[i].nodeValue.split(',');
                }

                // and push into array
                options[attrName] = attrValue;
            }
        }

        return options;
    }

});
